module.exports = __webpack_public_path__ + "static/media/account-tie-outline.9a663a41.svg";